// Nutrient Calculator Utility for React

const config = {
    nutrients: {
        COCO_CAL: [2.4, 2.4, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2, 1],
        VEG_A: [2.4, 2.4, 2.5, 0, 0, 0, 0, 0, 0, 0, 0],
        VEG_B: [2.4, 2.4, 2.5, 0, 0, 0, 0, 0, 0, 0, 0],
        BLOOM_A: [0, 0, 0, 3.5, 4.5, 6, 6, 7, 6, 4, 3],
        BLOOM_B: [0, 0, 0, 3.5, 4.5, 6, 6, 7, 6, 4, 3],
        BOOSTER_MID: [0, 0, 0, 0.5, 1.5, 2, 3, 3.5, 3, 2, 1.5],
        BOOSTER_MOAB: [0, 0, 0, 0.5, 0, 0, 0, 0, 1, 1.5, 0.5]
    },
    ec_values: [0.600, 0.600, 0.600, 0.9, 1.0, 1.2, 1.3, 1.5, 1.4, 1.0, 0.8],
    ppm_500_multipliers: [500, 500, 550, 472.2, 500, 500, 500, 500, 500, 550, 500],
    addback_formulas: {
        COCO_CAL: [true, true, true, true, true, true, true, true, true, true, true],
        VEG_A: [true, true, true, false, false, false, false, false, false, false, false],
        VEG_B: [true, true, true, false, false, false, false, false, false, false, false],
        BLOOM_A: [false, false, false, true, true, true, true, true, true, true, true],
        BLOOM_B: [false, false, false, true, true, true, true, true, true, true, true],
        BOOSTER_MID: [false, false, false, true, true, true, true, true, true, true, true],
        BOOSTER_MOAB: [false, false, false, false, false, false, false, false, true, true, true]
    }
};

const columnMap = {
    "VEG 1": 0, "VEG 2": 1, "VEG 3": 2,
    "BLOOM 1": 3, "BLOOM 2": 4, "BLOOM 3": 5, "BLOOM 4": 6,
    "BLOOM 5": 7, "BLOOM 6": 8, "BLOOM 7": 9, "BLOOM 8": 10
};

export function calculateNutrientColumn(systemVolume, currentPPM, columnName) {
    const columnIndex = columnMap[columnName];
    if (columnIndex === undefined) return {};
    const targetPPM = config.ec_values[columnIndex] * config.ppm_500_multipliers[columnIndex];
    const result = {};
    // COCO CAL
    if (config.addback_formulas.COCO_CAL[columnIndex]) {
        const baseAmount = systemVolume * config.nutrients.COCO_CAL[columnIndex];
        result["COCO CAL"] = Math.round(((targetPPM - currentPPM) / targetPPM) * baseAmount);
    } else { result["COCO CAL"] = ""; }
    // VEG A
    if (config.addback_formulas.VEG_A[columnIndex]) {
        const baseAmount = systemVolume * config.nutrients.VEG_A[columnIndex];
        result["VEG A"] = Math.round(((targetPPM - currentPPM) / targetPPM) * baseAmount);
    } else { result["VEG A"] = ""; }
    // VEG B
    if (config.addback_formulas.VEG_B[columnIndex]) {
        const baseAmount = systemVolume * config.nutrients.VEG_B[columnIndex];
        result["VEG B"] = Math.round(((targetPPM - currentPPM) / targetPPM) * baseAmount);
    } else { result["VEG B"] = ""; }
    // BLOOM A
    if (config.addback_formulas.BLOOM_A[columnIndex]) {
        const baseAmount = systemVolume * config.nutrients.BLOOM_A[columnIndex];
        result["BLOOM A"] = Math.round(((targetPPM - currentPPM) / targetPPM) * baseAmount);
    } else { result["BLOOM A"] = ""; }
    // BLOOM B
    if (config.addback_formulas.BLOOM_B[columnIndex]) {
        const baseAmount = systemVolume * config.nutrients.BLOOM_B[columnIndex];
        result["BLOOM B"] = Math.round(((targetPPM - currentPPM) / targetPPM) * baseAmount);
    } else { result["BLOOM B"] = ""; }
    // BOOSTER - Mid
    if (config.addback_formulas.BOOSTER_MID[columnIndex]) {
        const baseAmount = systemVolume * config.nutrients.BOOSTER_MID[columnIndex];
        result["BOOSTER - Mid"] = Math.round(((targetPPM - currentPPM) / targetPPM) * baseAmount);
    } else { result["BOOSTER - Mid"] = ""; }
    // BOOSTER - Late Grams
    if (config.addback_formulas.BOOSTER_MOAB[columnIndex]) {
        const baseAmount = systemVolume * config.nutrients.BOOSTER_MOAB[columnIndex];
        result["BOOSTER - Late Grams"] = Math.round(((targetPPM - currentPPM) / targetPPM) * baseAmount);
    } else { result["BOOSTER - Late Grams"] = ""; }
    return result;
}

export const nutrientColumnNames = Object.keys(columnMap);